<template>
  <div :style="{'height': `${item.height}px`}">
    <div v-if="item.type === 'personHeader'" class="item-type-header">
      <div class="header-h3">{{ $t('flight-orders.header-persons') }}</div>
    </div>
    <div v-if="item.type === 'cargoHeader'" class="item-type-header">
      <div class="header-h3">{{ $t('flight-orders.header-cargoes') }}</div>
    </div>
    <div>
      <div style="display: flex; height: 32px; background-color: #eee;" :class="['tr', (selectable && 'selectable')]" @click="onClick">
        <!--<div v-if="selectable" class="row-checkbox"></div>-->
        <!--<div class="td index"></div>-->
        <div class="td">
          <div class="info">
            <svg-icon icon-class="personCircle" style="opacity: 0" />
          </div>
        </div>

        <ul v-if="cColumns" class="item-columns">
          <template v-for="columnKey in cColumnsValues">
            <li :key="columnKey" :data-key="columnKey" class="item-column">
              <el-divider direction="vertical" />
              <div :class="['info']" :style="getColStyle(columnKey, item.type)" :data-col-key="columnKey" :title="columnNames[item.type][columnKey]">
                <span>{{ columnNames[item.type][columnKey] }}</span>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import columns from "@/store/modules/columns";

function isFloat(n){
  return Number(n) === n && n % 1 !== 0;
}
export default {
  name: 'FlightOrderHeader',
  props: ['item', 'index', 'columns', 'options', 'selectable', 'tableKeyPrefix', 'colWidth'],
  data: () => ({
    colMinWidth: {
      'flightDateString': 75,
      'depPortLabels.code': 40,
      'arrPortLabels.code': 40,
      'from': 150,
      'to': 150,
      'pnr': 45,
      'shortName': 110,
      'orderData.fullName': 250,
      'orderData.docNum': 70,
      'orderData.name': 100,
      'orderData.mvz': 50,
      'birthDateStr': 75,
      'orderData.contacts': 100,
      'orderData.email': 100,
      'orderData.timeFrom': 50,
      'processData.orderStatus': 100,
      'orderData.initiator': 70,
      'orderData.initiatorEmail': 70,
      'orderData.initiatorPhone': 70,

      'orderData.transportType': 50,
      'orderData.packType': 70,
      'orderData.dimensions': 140,
      'organization': 140,
      'orderData.weight': 60,
      'orderData.placeCount': 30,

      'medcheck': 110,
      'registered': 100
    }
  }),
  computed: {
    cColumns () {
      return this.item.type === 'personHeader' ? this.cPersonColumns : this.cCargoColumns
    },
    cColumnsValues () {
      let values = this.renderColumns(this.item.value, this.cColumns)
      if (this.editMode) {
        const index = values.map(v => v.key).indexOf('processData.orderStatus')
        if (index > -1) {
          values.splice(index, 1)
        }
      }
      // console.table(values)
      return values
    },
    cPersonColumns () {
      return this.$store.getters.tableColumns.columnsHolder[this.tableKeyPrefix + '-personColumns']
      // let columns = this.$store.getters.tableColumns.columns.getOrDefault(
      //   this.tableKeyPrefix + '-personColumns',
      //   [
      //     // route
      //     'flightDateString',
      //     'depPortLabels.code',
      //     'arrPortLabels.code',
      //     // passenger data
      //     'pnr',
      //     'shortName',
      //     'orderData.docNum',
      //     'orderData.mvz',
      //     'organization',
      //     'birthDateStr',
      //     'orderData.contacts',
      //     'orderData.email',
      //     // initiator
      //     'orderData.initiator',
      //     'orderData.initiatorEmail',
      //     'orderData.initiatorPhone',
      //     //
      //     'orderData.timeFrom',
      //     //
      //     'processData.orderStatus'
      //   ]
      // )
      // console.log('columns Person: %o', columns)
      // return columns
    },
    cCargoColumns () {
      return this.$store.getters.tableColumns.columnsHolder[this.tableKeyPrefix + '-cargoColumns']
      // let columns = this.$store.getters.tableColumns.columns.getOrDefault(
      //   this.tableKeyPrefix + '-cargoColumns',
      //   [
      //     'flightDateString', 'depPortLabels.code', 'arrPortLabels.code',
      //     'pnr',
      //     'orderData.placeCount',
      //     'orderData.name',
      //     'orderData.dimensions',
      //     'orderData.weight',
      //     //
      //     'orderData.mvz',
      //     'organization',
      //     //
      //     'orderData.packType',
      //     'orderData.transportType',
      //     // initiator
      //     'orderData.initiator',
      //     'orderData.initiatorEmail',
      //     'orderData.initiatorPhone',
      //     //
      //     'orderData.timeFrom',
      //     //
      //     'processData.orderStatus'
      //   ]
      // )
      // console.log('columns Cargo: %o', columns)
      // return columns
    },
    columnNames () {
      const personHeader = this.cPersonColumns.reduce((acc, columnKey) => {
        acc[columnKey] = this.$t(`flight-orders.columns.${columnKey}`)
        return acc
      }, {})
      const cargoHeader = this.cCargoColumns ? this.cCargoColumns.reduce((acc, columnKey) => {
        acc[columnKey] = this.$t(`flight-orders.columns.${columnKey}`)
        return acc
      }, {}) : {}
      return {
        personHeader,
        cargoHeader
      }
    }
  },
  methods: {
    getColStyle (key, typeHeader) {
      let type = null
      if (typeHeader === 'personHeader') {
        type = 'columnWidthPerson'
      } else if (typeHeader === 'cargoHeader') {
        type = 'columnWidthCargo'
      }
      if (this.tableKeyPrefix === 'uploadOrdersPreview') {
        // debugger
      }
      if (this.colWidth[type] !== {}) {
        if (!this.colWidth[type][key]) {
          return null
        }
        return {'width': this.colWidth[type][key] + 'px' }
      } else {
        if (!this.colMinWidth[key]) {
          return null
        }
        const isF = isFloat(this.colMinWidth[key])
        return {'width': this.colMinWidth[key] + (isF ? 'em' : 'px') }
      }
    },
    renderColumns (itemValue, columns) {
      return columns
    },
    onClick (event) {
      if (this.item.inactive !== true) {
        this.$emit('click:item', this.item, event)
      }
    },
  }
}
</script>
<style scoped>
  .item-type-header {
    margin: 0px 10px;
  }
  .header-h3 {
    font-size: 1.17em;
    /*margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;*/
    padding: 10px;
    font-weight: bold;
  }

  .row-checkbox {
    width: 62px;
    text-align: right;
    flex: auto 0 0;
    float: left;
  }
  .index {
    width: 55px;
    text-align: right;
    flex: auto 0 0;
    float: left;
  }
  ul.item-columns {
    display: flex;
    margin: 0px;
    margin-right: 6px;
    padding: 0;
    align-items: center;
  }
  ul.item-columns li.item-column {
    border: none;
    display: inline-flex;
    outline: none;
    position: relative;
    z-index: 0;
    list-style: none;
  }

  .info {
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    white-space: nowrap;
  }

  .td:first-child {
    padding: 6px;
  }
  .td .info .svg-icon {
    width: 1.4rem;
    height: 1.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/flight-orders/scrolled/FlightOrderHeader.vue